import { Component, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, FormGroup, FormArray, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { ConditionFormComponentData } from 'src/app/shared/database-rule/database-rule-condition/database-rule-condition.component';

export interface GroupControlComponentData {
  conjunctor: null;
  conditions: ConditionFormComponentData[];
  groups: GroupControlComponentData[];
}
@Component({
  selector: 'calsoft-database-rule-component-advanced',
  templateUrl: './database-rule-component-advanced.component.html',
  styleUrls: ['./database-rule-component-advanced.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatabaseRuleComponentAdvancedComponent),
      multi: true
    }
  ]
})
export class DatabaseRuleComponentAdvancedComponent {
  @Input()
  formLabel: string | number = "Group";

  @Input()
  ruleId: any = 0;

  @Input()
  type: any = 0;

  @Input() formGroup!: FormGroup;

  @Input() mainForm!: FormGroup;

  @Output()
  remove: EventEmitter<void> = new EventEmitter<void>();

  _form: UntypedFormGroup;

  private _onChange: (
    value: GroupControlComponentData | null | undefined
  ) => void;

  private _destroy$: Subject<void> = new Subject<void>();

  constructor(private _fb: UntypedFormBuilder) { }

  ngOnInit() {

    this._form = this.formGroup;

    console.log("form", this._form);




    this._form.patchValue(this.formGroup.value)



    this._setupObservables();
  }

  ngOnDestroy() {
    if (this._destroy$ && !this._destroy$.closed) {
      this._destroy$.next();
      this._destroy$.complete();
    }
  }

  writeValue(value: GroupControlComponentData | null | undefined): void {
    if (!value) {
      return;
    }
    setTimeout(() => {
      if (value.conditions) {
        this._conditionsFormArray.clear();
        value.conditions.forEach(c => this._addCondition());
      }

      if (value.groups) {
        this._groupsFormArray.clear();
        value.groups.forEach(g => this._addGroup());
      }

      this._form.patchValue(value);

      this.formGroup.patchValue(value)
    }, 50);
  }

  registerOnChange(
    fn: (value: GroupControlComponentData | null | undefined) => void
  ): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {

  }

  _deleteCondition(index: number) {
    this._conditionsFormArray.removeAt(index);
  }

  _addCondition() {

    const conditionsArray = this._form.get('conditions') as FormArray;

    conditionsArray.push(
      this._fb.group({

        fieldName: [null, [Validators.required]],
        operators: [null, [Validators.required]],
        fieldValue: [null, [Validators.required]],
        startDate: [null, []],
        endDate: [null, []]
      })
    );
  }

  _deleteGroupFromArray(index: number) {
    this._groupsFormArray.removeAt(index);
  }

  _addGroup() {

    const conditions = this._form.get('conditions') as FormArray;


    if (!conditions || conditions.length === 0) {
      alert('Please add at least one condition before creating a group.');
      return;
    }

    const groupsArray = this._form.get('groups') as FormArray;

    groupsArray.push(
      this._fb.group({
        conjunctor: ['AND'],
        conditions: this._fb.array([]),
        groups: this._fb.array([])
      })
    );
    this.formGroup = this._form;
  }

  get _conditionsFormArray(): UntypedFormArray {
    return this._form.get("conditions") as UntypedFormArray;
  }

  get _groupsFormArray(): UntypedFormArray {
    return this._form.get("groups") as UntypedFormArray;
  }

  private _createFormGroup() {
    this._form = this._fb.group({
      conjunctor: ['AND'],
      conditions: this._fb.array([]),
      groups: this._fb.array([])
    });


    setTimeout(() => this._addCondition());
  }

  private _setupObservables() {
    this._form.valueChanges.pipe(takeUntil(this._destroy$)).subscribe(value => {
      if (this._onChange) {
        this._onChange(value);
      }
    });
  }
  condition: any = [
    'AND', 'OR'
  ]
}

